import { TProps } from './types/TProps';

const headerClassName = [
  'flex min-w-0 items-center justify-between gap-1 px-[5px] pb-[3px] pt-[5px]',
  'text-[var(--color-form-field-datepicker-text,var(--color-form-field-text,var(--color-text)))]',
  '[&_button]:flex-shrink-0 [&_button]:rounded-[5px] [&_button]:p-2.5',
  '[&_button]:!text-[var(--color-form-field-datepicker-icon,var(--color-form-field-icon,var(--color-text-muted)))]',
  '[&_button:hover]:bg-[var(--color-tint)]',
  '[&_button:hover]:!text-[var(--color-form-field-datepicker-text,var(--color-form-field-text,var(--color-text)))]',
  '[&_svg]:cursor-pointer',
].join(' ');

export const FormFieldDatePickerHeader = ({ className = '', children }: TProps) => (
  <div className={[headerClassName, className].filter(Boolean).join(' ')}>{children}</div>
);
